import React from 'react'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import {checkIsActive, KTSVG, WithChildren} from '../../../helpers'
import {useLayout} from '../../core'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  biIcon?: string
  hasBullet?: boolean
}

const AsideMenuItem: React.FC<Props & WithChildren> = ({
  children,
  to,
  title,
  icon,
  biIcon,
  hasBullet = false,
}) => {
  const {pathname} = useLocation()
  const isActive = checkIsActive(pathname, to)
  const {config} = useLayout()
  const {aside} = config

  return (
    <div className='menu-item' style={{margin: '2px 0'}}>
      <Link
        to={to}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          padding: '10px 16px',
          borderRadius: '10px',
          textDecoration: 'none',
          background: isActive ? 'rgba(232, 64, 64, 0.1)' : 'transparent',
          color: isActive ? 'var(--text-primary)' : 'var(--text-muted)',
          fontWeight: isActive ? 600 : 500,
          fontSize: '14px',
          transition: 'all 0.15s',
          position: 'relative',
          borderLeft: isActive ? '3px solid #E84040' : '3px solid transparent',
        }}
        onMouseEnter={(e) => {
          if (!isActive) {
            e.currentTarget.style.background = 'var(--elevated-bg)'
            e.currentTarget.style.color = 'var(--text-secondary)'
          }
        }}
        onMouseLeave={(e) => {
          if (!isActive) {
            e.currentTarget.style.background = 'transparent'
            e.currentTarget.style.color = 'var(--text-muted)'
          }
        }}
      >
        {hasBullet && (
          <span
            style={{
              width: '5px',
              height: '5px',
              borderRadius: '50%',
              background: 'currentColor',
              flexShrink: 0,
            }}
          />
        )}
        {biIcon && (
          <i
            className={`bi ${biIcon}`}
            style={{
              fontSize: '16px',
              flexShrink: 0,
              color: isActive ? '#E84040' : 'var(--text-muted)',
            }}
          />
        )}
        {icon && !biIcon && aside.menuIcon === 'svg' && (
          <span style={{flexShrink: 0}}>
            <KTSVG path={icon} className='svg-icon-5' svgClassName=' ' />
          </span>
        )}
        <span>{title}</span>
      </Link>
      {children}
    </div>
  )
}

export {AsideMenuItem}
